import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import _ from 'lodash'
import classNames from 'classnames/bind'
import CoBuyerForm from '../coBuyerForm'
import Title from '../../../title'
import { ConfirmationModal } from '@adc/ui-core'
import { MULTI_CO_BUYER_FORM_NAME } from '../constants'
import styles from './styles.scss'

const cx = classNames.bind(styles)
const selector = formValueSelector(MULTI_CO_BUYER_FORM_NAME)

// handles opening multiple sub entity forms
class CoBuyerFormWrapper extends Component {
  static propTypes = {
    fields: PropTypes.any,
    // eslint-disable-next-line react/no-unused-prop-types
    fieldValues: PropTypes.object,
    index: PropTypes.number,
    formKey: PropTypes.string,
    onCoBuyerClose: PropTypes.func,
    isAutoCapitalize: PropTypes.bool,
  }

  static defaultProps = {
    showTitlesOnly: false,
    onCoBuyerClose: _.noop,
  }

  state = {
    closeConfirmationModalOpen: false,
    contentOpened: true,
  }

  onCloseTitle = _ => {
    this.setState({
      closeConfirmationModalOpen: true,
    })
  }

  onCloseCoBuyerModal = _ => {
    this.setState({
      closeConfirmationModalOpen: false,
    })
  }

  onRemoveCoBuyerModal = _ => {
    const { onCoBuyerClose, index } = this.props
    this.setState(
      {
        closeConfirmationModalOpen: false,
      },
      onCoBuyerClose(index)
    )
  }

  getRemoveModalBody = (firstName, lastName) => {
    const renderName =
      firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName
    return `Are you sure you want to remove ${
      renderName ? `${renderName} as a` : 'this'
    } co-buyer?`
  }

  onToggleTitle = () => {
    const { contentOpened } = this.state
    this.setState({ contentOpened: !contentOpened })
  }

  render() {
    const { fields, index, formKey, isAutoCapitalize } = this.props
    const { contentOpened, closeConfirmationModalOpen } = this.state
    const firstName = _.get(fields.get(index), 'firstName', '')
    const lastName = _.get(fields.get(index), 'lastName', '')

    return (
      <div>
        <div className={cx('root')}>
          <ConfirmationModal
            title='Confirm Co-Buyer Deletion'
            open={closeConfirmationModalOpen}
            onClose={this.onCloseCoBuyerModal}
            onConfirm={this.onRemoveCoBuyerModal}
          >
            <span>{this.getRemoveModalBody(firstName, lastName)}</span>
          </ConfirmationModal>
          <Title
            mainContent={`${firstName} ${lastName}`}
            subContent={`Co-Buyer ${index + 1}`}
            onClose={this.onCloseTitle}
            onToggle={this.onToggleTitle}
            elmId={formKey}
            removeable={fields.length === 1}
            useWhiteSpaceTitle
          />
          <div
            className={cx('wrapper', {
              'title-only': !contentOpened,
            })}
          >
            <CoBuyerForm
              key={index}
              fields={fields}
              formKey={formKey}
              index={index}
              isAutoCapitalize={isAutoCapitalize}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default connect((state, props) => {
  return {
    fieldValues: selector(state, props.formKey),
  }
})(CoBuyerFormWrapper)
